<!-- static content data from lang: site_management -->
<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.headerTitle}}</h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6" v-loading="loading">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
             <div class="col-12">
                 <FlashMessages > </FlashMessages>
                 <template v-for="(message) in alertMessages">
                 <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
               </template>
                 <template v-for="(message) in successMessages">
                 <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
               </template>
              </div>
          <div>
            <div class="col-12 text-right mb-3">
              <base-button type="primary" @click="addClick()">{{lang.label.buttons.add}}</base-button>
            </div>
            <div class="col-12 text-center text-lg-left">
              <div class="row">
                <div
                  class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    autocomplete="off"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>

                  <div>
                    <base-input
                      v-model="searchQuery"
                      autocomplete="off"
                      prepend-icon="fas fa-search"
                      :placeholder="lang.label.search"
                    ></base-input>
                  </div>
                </div>
              </div>
            </div>
          <div class="col-12">
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
              border
            >
              <el-table-column min-width="250px" label="Company Name" prop="CompanyName" sortable></el-table-column>
              <el-table-column min-width="250px" label="Site Name" prop="Name" sortable></el-table-column>
              <el-table-column width="200px" align="right" label="Actions">
                <div class="d-flex" slot-scope="scope">
                  <el-tooltip :content="lang.label.tooltips.edit" placement="bottom">
                    <base-button class="btn-link" type="info" size="sm" icon @click="edit(scope.row.ID)">
                      <i class="text-white fas fa-pencil-alt"></i>
                    </base-button>
                  </el-tooltip>
                  <el-tooltip :content="lang.label.tooltips.delete" placement="bottom">
                    <base-button class="btn-link" type="danger" size="sm" icon @click.native="showSwal(scope.row.ID)">
                      <i class="text-white fas fa-trash-alt"></i>
                    </base-button>
                  </el-tooltip>

                </div>
              </el-table-column>
            </el-table>
          </div>
          </div>
          <div
            class="col-12 mt-3 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{lang.label.showPagination.showing}} {{ from + 1 }} {{lang.label.showPagination.to}} {{ to }} {{lang.label.showPagination.of}} {{ total }} {{lang.label.showPagination.entries}}
                <span
                  v-if="selectedRows.length"
                >&nbsp; &nbsp; {{selectedRows.length}} {{lang.label.showPagination.rowsSelected}}</span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {mapGetters} from "vuex";
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { Modal } from "@/components";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Alert from "@/components/BaseAlert.vue";
import FlashMessages from "@/views/GeneralViews/flash-message.vue";


export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        flatPicker,
        Alert,
    FlashMessages
    },
    data() {
        return {
            lang: this.$lang.site_management,
            loading:true,
            alertType: 'danger',
            successType: 'success',
            alertMessages: [],
            successMessages: [],
            propsToSearch: ["Name", "CompanySiteName"],
            selectedindex: 0,
            tableColumns: [
                {
                    type: "selection"
                }
            ],
            tableData: [],
            selectedRows: [],
            showSwal(id, row) {
                swal.fire({
                        title: "Are you sure?",
                        text: "Do you really want to delete this record? Deleting this will also delete it's corresponding child data as well.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes, delete it!",
                        cancelButtonText: "No, keep it",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-primary btn-fill",
                            cancelButton: "btn btn-danger btn-fill"
                        }
                    }).then(result => {
                        if (result.value) {
                           this.delete(id);
                        } else if (result.dismiss === swal.DismissReason.cancel) {
                        }
                    });
            },

        };
    },
    computed: {
        ...mapGetters({
            login: "login",
        }),
    },
    mounted() {
        this.getDevice();
    },
    methods: {
        getDevice(){
            this.$store.dispatch('siteList').then(response => {
                this.tableData = response.data;
                 this.loading = false;
            });
        },
        delete(id) {
          this.loading = true;
            let self = this;
            this.$store.dispatch('deleteSite', id).then(response => {
                self.successMessages.push(response.data.message);
                setTimeout(function () {
                    self.successMessages = [];
                },5000)
                self.getDevice();
            });
        },
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        },
        addClick() {
            this.$router.push({path: "add"});
        },
        edit(id){
            this.$router.push({path: "edit/"+id});
        },
        onSubmit() {

        }
    }
}
</script>

<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
</style>
